import { jsx as r, Fragment as i, jsxs as n } from "react/jsx-runtime";
import { useState as c } from "react";
import { classes as p } from "../../utils/styles.js";
import { useTranslation as d } from "../../hooks/useTranslation.js";
import "../Context/index.js";
import "../IconButton/index.js";
import "../../pagination-BeOG0tbT.js";
import "../ProductTable/TableRowGroup.js";
import "../../types/apiSchema.js";
import "../../types/localizationSchema.js";
import o from "./productcardlist.module.js";
const v = ({
  children: t,
  limit: s = 5,
  direction: a = "vertical"
}) => {
  const [e, m] = c(!1), { t: l } = d();
  return /* @__PURE__ */ r(i, { children: Array.isArray(t) && t.length >= s + 2 && !e ? /* @__PURE__ */ n(i, { children: [
    /* @__PURE__ */ r(
      "div",
      {
        className: p([
          o.productCardListBody,
          ...a === "horizontal" ? [o.horizontal] : []
        ]),
        children: t.slice(0, s)
      }
    ),
    /* @__PURE__ */ r(
      "button",
      {
        onClick: () => m(!0),
        className: o.productcardlistButton,
        children: l("show_more_batches")
      }
    )
  ] }) : t });
};
export {
  v as ProductCardList
};
